<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="vdp-offers">
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="vdpOfferWidgetEnabled">VDP Offer Display
          <i class="pi pi-info-circle"
             pTooltip="When enabled, MPOP Offer data and CTA will be displayed on dealer VDP pages when the data is matched by VIN."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <p-toggleswitch
          id="vdpOfferWidgetEnabled"
          formControlName="vdpOfferWidgetEnabled">
        </p-toggleswitch>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="offerTextColor">Offer Text Color
          <i class="pi pi-info-circle"
             pTooltip="Color used for the standard VDP payment text in the offer widget."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <div class="offer-text-color-control">
          <input id="offerTextColor"
                 type="color"
                 formControlName="offerTextColor"
                 class="offer-text-color-swatch" />
          <input
            type="text"
            class="offer-text-color-hex"
            [value]="form?.get('offerTextColor')?.value"
            (input)="form?.get('offerTextColor')?.setValue($any($event.target).value); form?.get('offerTextColor')?.markAsDirty()"
          />
        </div>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <label class="field-input-label tab-input-label label-field">
        CTA Text Font Size
        <i class="pi pi-info-circle"
           pTooltip="Configure the font size of the main call-to-action text on VDP."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper cta-text-font-size-input" type="number" formControlName="ctaTextFontSize">
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="ctaButtonColor">CTA Button Color
          <i class="pi pi-info-circle"
             pTooltip="Configure the color of the main call-to-action button on VDP."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <div class="offer-text-color-control">
          <input id="ctaButtonColor"
                 type="color"
                 formControlName="ctaButtonColor"
                 class="offer-text-color-swatch" />
          <input
            type="text"
            class="offer-text-color-hex"
            [value]="form?.get('ctaButtonColor')?.value"
            (input)="form?.get('ctaButtonColor')?.setValue($any($event.target).value); form?.get('ctaButtonColor')?.markAsDirty()"
          />
        </div>
      </div>
    </div>
    <div class="tab-panel-input-wrapper click-to-call-section">
      <div class="field-input-label tab-input-label label-field">
        <label for="clickToCallEnabled">Click-to-Call CTA
          <i class="pi pi-info-circle"
             pTooltip="When enabled, a Click-to-Call button will be displayed in the VDP offer widget so shoppers can tap to call the dealer."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <p-toggleswitch
          id="clickToCallEnabled"
          formControlName="clickToCallEnabled">
        </p-toggleswitch>
      </div>
    </div>
    <div class="tab-panel-input-wrapper click-to-call-sub-setting" *ngIf="form?.get('clickToCallEnabled')?.value">
      <div class="field-input-label tab-input-label label-field">
        <label for="clickToCallTextColor">Click-to-Call Text Color
          <i class="pi pi-info-circle"
             pTooltip="Text color for the Click-to-Call button in the VDP offer widget."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <div class="offer-text-color-control">
          <input id="clickToCallTextColor"
                 type="color"
                 formControlName="clickToCallTextColor"
                 class="offer-text-color-swatch" />
          <input
            type="text"
            class="offer-text-color-hex"
            [value]="form?.get('clickToCallTextColor')?.value"
            (input)="form?.get('clickToCallTextColor')?.setValue($any($event.target).value); form?.get('clickToCallTextColor')?.markAsDirty()"
          />
        </div>
      </div>
    </div>
    <div class="tab-panel-input-wrapper click-to-call-sub-setting" *ngIf="form?.get('clickToCallEnabled')?.value">
      <div class="field-input-label tab-input-label label-field">
        <label for="clickToCallText">Click-to-Call Text
          <i class="pi pi-info-circle"
             pTooltip="Text shown on the Click-to-Call button. Use [DealerPhone] to insert the dealer phone number."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <input
          id="clickToCallText"
          pInputText
          class="input-text-wrapper"
          type="text"
          formControlName="clickToCallText">
      </div>
    </div>
    <div class="tab-panel-input-wrapper click-to-call-sub-setting" *ngIf="form?.get('clickToCallEnabled')?.value">
      <div class="field-input-label tab-input-label label-field">
        <label for="clickToCallTextFontSize">Click-to-Call Text Font Size
          <i class="pi pi-info-circle"
             pTooltip="Configure the font size of the Click-to-Call button text."
             tooltipPosition="top"></i></label>
      </div>
      <input pInputText class="input-text-wrapper cta-text-font-size-input" type="number" formControlName="clickToCallTextFontSize">
    </div>
    <div class="tab-panel-input-wrapper click-to-call-sub-setting" *ngIf="form?.get('clickToCallEnabled')?.value">
      <div class="field-input-label tab-input-label label-field">
        <label for="clickToCallBackgroundColor">Click-to-Call Button Color
          <i class="pi pi-info-circle"
             pTooltip="Background color for the Click-to-Call button in the VDP offer widget."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <div class="offer-text-color-control">
          <input id="clickToCallBackgroundColor"
                 type="color"
                 formControlName="clickToCallBackgroundColor"
                 class="offer-text-color-swatch" />
          <input
            type="text"
            class="offer-text-color-hex"
            [value]="form?.get('clickToCallBackgroundColor')?.value"
            (input)="form?.get('clickToCallBackgroundColor')?.setValue($any($event.target).value); form?.get('clickToCallBackgroundColor')?.markAsDirty()"
          />
        </div>
      </div>
    </div>
    <div class="tab-panel-input-wrapper">
      <div class="field-input-label tab-input-label label-field">
        <label for="showCtaWithoutOffers">Show CTA Without Offers
          <i class="pi pi-info-circle"
             pTooltip="When enabled, the Main CTA button will display on Vehicle Detail Pages even if no offers or discounts are available, increasing opportunities for shopper engagement."
             tooltipPosition="top"></i></label>
      </div>
      <div class="field-switch-label">
        <p-toggleswitch
          id="showCtaWithoutOffers"
          formControlName="showCtaWithoutOffers">
        </p-toggleswitch>
      </div>
    </div>
  </div>
</form>
